import { render, staticRenderFns } from "./ListManualOrder.vue?vue&type=template&id=008c9670"
import script from "./ListManualOrder.vue?vue&type=script&lang=js"
export * from "./ListManualOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports